(function () {
// VoiceRSS Javascript SDK
const $3762ceed473a0440$export$f93563f1d43da462 = {
    // Call validation and request functions with the settings object
    speech: function(e) {
        this._validate(e), this._request(e);
    },
    // Validation function to check if the settings object has the required properties
    _validate: function(e) {
        if (!e) throw "The settings are undefined";
        if (!e.key) throw "The API key is undefined";
        if (!e.src) throw "The text is undefined";
        if (!e.hl) throw "The language is undefined";
        // If the audio codec is not set to auto, check if the browser supports the codec
        if (e.c && "auto" != e.c.toLowerCase()) {
            var a = !1;
            switch(e.c.toLowerCase()){
                case "mp3":
                    a = (new Audio).canPlayType("audio/mpeg");
                    break;
                case "wav":
                    a = (new Audio).canPlayType("audio/wav");
                    break;
                case "aac":
                    a = (new Audio).canPlayType("audio/aac");
                    break;
                case "ogg":
                    a = (new Audio).canPlayType("audio/ogg");
                    break;
                case "caf":
                    a = (new Audio).canPlayType("audio/x-caf");
            }
            if (!a) throw "The browser does not support the audio codec " + e.c;
        }
    },
    _request: async function(e) {
        try {
            const response = await fetch("https://api.voicerss.org/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
                },
                body: this._buildRequest(e)
            });
            if (response.ok) {
                const result = await response.text();
                if (e.audioElement instanceof HTMLAudioElement) {
                    e.audioElement.src = result;
                    e.audioElement.play();
                } else throw "audioElement must be an instance of HTMLAudioElement";
            } else {
                const error = await response.text();
                throw error;
            }
        } catch (error) {
            console.log(error);
        }
    },
    // Build the request string
    _buildRequest: function(e) {
        // If there is a codec in the settings object, set the codec to the value of the codec, otherwise call the detectCodec function
        var a = e.c && "auto" != e.c.toLowerCase() ? e.c : this._detectCodec();
        // Return the request string with the key, text, language, rate, codec, format, and ssml
        return `key=${e.key || ""}&src=${e.src || ""}&hl=${e.hl || ""}&r=${e.r || ""}&c=${a || ""}&f=${e.f || ""}&ssml=${e.ssml || ""}&b64=true`;
    },
    // Detect the audio codec supported by the browser
    _detectCodec: function() {
        // Create an audio element
        var e = new Audio;
        // Check if the browser supports the audio codecs and return the codec
        return e.canPlayType("audio/mpeg") ? "mp3" : e.canPlayType("audio/wav") ? "wav" : e.canPlayType("audio/aac") ? "aac" : e.canPlayType("audio/ogg") ? "ogg" : e.canPlayType("audio/x-caf") ? "caf" : "";
    },
    // Try to create an instance of the XMLHttpRequest object, if it fails, try to create an instance of the ActiveXObject object with the specified versions
    _getXHR: function() {
        try {
            // Works in modern browsers
            return new XMLHttpRequest;
        } catch (e) {}
        try {
            // Works in IE7 and IE8
            return new ActiveXObject("Msxml3.XMLHTTP");
        } catch (e) {}
        try {
            // Works in IE6
            return new ActiveXObject("Msxml2.XMLHTTP.6.0");
        } catch (e) {}
        try {
            //Works in IE5
            return new ActiveXObject("Msxml2.XMLHTTP.3.0");
        } catch (e) {}
        try {
            // Works in Firefox, Opera and Chrome
            return new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e) {}
        try {
            // For everything else, return a standard HTTP request
            return new ActiveXObject("Microsoft.XMLHTTP");
        } catch (e) {}
        throw "The browser does not support HTTP request";
    }
};


const $5b27415bf05f75f7$var$playButton = document.getElementById("button");
const $5b27415bf05f75f7$var$audioElement = document.getElementById("audio");
const $5b27415bf05f75f7$var$nsfwSwitch = document.getElementById("settings-nsfw__input");
const $5b27415bf05f75f7$var$nsfwModeButton = document.getElementById("nsfw-dark");
const $5b27415bf05f75f7$var$customCheckboxes = Array.from(document.getElementsByClassName("checkbox-container"));
const $5b27415bf05f75f7$var$selectAllCheckbox = document.getElementById("all-checkbox");
//* API Key
const $5b27415bf05f75f7$var$apiKey = "f83cf3c984414c67b2a8240b169e56c2"; // Replace with your own API key
//* User Settings
let $5b27415bf05f75f7$var$userCategories = [];
let $5b27415bf05f75f7$var$nsfwMode = false;
// Append nsfw string to API URL to filter out nsfw jokes by default
let $5b27415bf05f75f7$var$nsfwString = "?blacklistFlags=nsfw,religious,political,racist,sexist,explicit";
// Hide 'dark' category option by default
if ($5b27415bf05f75f7$var$nsfwModeButton) $5b27415bf05f75f7$var$nsfwModeButton.style.display = "none";
// Get jokes from Joke API
async function $5b27415bf05f75f7$var$getJoke() {
    $5b27415bf05f75f7$var$getUserCategories();
    const apiUrl = `https://v2.jokeapi.dev/joke/${$5b27415bf05f75f7$var$userCategories}${$5b27415bf05f75f7$var$nsfwString}`;
    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        // check if joke is single or double and set joke string accordingly
        const joke = data.joke ? data.joke : data.setup + "..." + data.delivery;
        // Text-to-Speech function
        $5b27415bf05f75f7$var$playAudio(joke);
    } catch (error) {
        // catch error here
        console.error("Error fetching jokes -", error);
    }
}
// Passing joke string to VoiceRSS TTS as src parameter and audioElement for playing audio
function $5b27415bf05f75f7$var$playAudio(userString) {
    (0, $3762ceed473a0440$export$f93563f1d43da462).speech({
        key: $5b27415bf05f75f7$var$apiKey,
        src: userString,
        hl: "en-us",
        r: "0",
        c: "mp3",
        f: "44khz_16bit_stereo",
        ssml: "false",
        audioElement: $5b27415bf05f75f7$var$audioElement
    });
}
function $5b27415bf05f75f7$var$getUserCategories() {
    // Clear userCategories array
    $5b27415bf05f75f7$var$userCategories = [];
    // Add user selected categories to userCategories array
    $5b27415bf05f75f7$var$customCheckboxes.forEach((checkbox)=>{
        if (checkbox.childNodes[1].checked && $5b27415bf05f75f7$var$userCategories) $5b27415bf05f75f7$var$userCategories.push(checkbox.childNodes[0].textContent?.trimEnd());
    });
    // If user selected 'All' or no categories, set userCategories to 'Any'
    if ($5b27415bf05f75f7$var$userCategories.length === 0 || $5b27415bf05f75f7$var$userCategories[0] === "All") $5b27415bf05f75f7$var$userCategories = [
        "Any"
    ];
    else $5b27415bf05f75f7$var$userCategories = $5b27415bf05f75f7$var$userCategories.filter((category)=>category !== "All");
    // Join userCategories array into a string
    $5b27415bf05f75f7$var$userCategories.join(",");
}
// Event listeners
$5b27415bf05f75f7$var$playButton?.addEventListener("click", $5b27415bf05f75f7$var$getJoke);
// Toggle nsfw mode
$5b27415bf05f75f7$var$nsfwSwitch?.addEventListener("change", ()=>{
    $5b27415bf05f75f7$var$nsfwMode = $5b27415bf05f75f7$var$nsfwSwitch.checked;
    if ($5b27415bf05f75f7$var$nsfwMode) {
        $5b27415bf05f75f7$var$nsfwString = "";
        $5b27415bf05f75f7$var$nsfwModeButton && ($5b27415bf05f75f7$var$nsfwModeButton.style.display = "block");
    } else {
        $5b27415bf05f75f7$var$nsfwString = "?blacklistFlags=nsfw,religious,political,racist,sexist,explicit";
        if ($5b27415bf05f75f7$var$nsfwModeButton) {
            $5b27415bf05f75f7$var$nsfwModeButton.style.display = "none";
            $5b27415bf05f75f7$var$nsfwModeButton.childNodes[1].checked = false;
        }
    }
});
// Disable the All checkbox if any other checkbox is checked
$5b27415bf05f75f7$var$customCheckboxes.forEach((checkbox)=>{
    checkbox.addEventListener("change", ()=>{
        if (checkbox.childNodes[1].id === "all-checkbox") return;
        else if ($5b27415bf05f75f7$var$selectAllCheckbox) $5b27415bf05f75f7$var$selectAllCheckbox.checked = false;
    });
});
// Toggle all checkboxes on or off when the All checkbox is checked
if ($5b27415bf05f75f7$var$selectAllCheckbox) $5b27415bf05f75f7$var$selectAllCheckbox.addEventListener("change", ()=>{
    if ($5b27415bf05f75f7$var$selectAllCheckbox.checked) $5b27415bf05f75f7$var$customCheckboxes.filter((checkbox)=>$5b27415bf05f75f7$var$nsfwMode ? checkbox : checkbox.id !== "nsfw-dark").forEach((checkbox)=>checkbox.childNodes[1].checked = true);
    else $5b27415bf05f75f7$var$customCheckboxes.forEach((checkbox)=>checkbox.childNodes[1].checked = false);
});

})();
//# sourceMappingURL=index.e4dd9564.js.map
